import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { InteractionType, BrowserCacheLocation, PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../../../environments/environment';
import { routesPath } from '../constants/app.constants';

//Inicializar variables
if(!environment.initialized){
    environment.appFrontend.authority = environment.appFrontend.authority.replace('_TENANT_ID_', environment.appFrontend.tenantId);
    environment.appBackend.accessScope = environment.appBackend.accessScope.replace('_AUTH_API_CLIENT_ID_', environment.appBackend.clientId);
    environment.appBackend.scopes = [... environment.appBackend.scopes,environment.appBackend.accessScope]
    environment.initialized = true;
}

export const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export const msalConfig = {
  auth: {
    clientId: environment.appFrontend.clientId,
    authority: environment.appFrontend.authority,
    redirectUri: environment.appFrontend.redirect.url,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: isIE
  }
};

export function MSALInstanceFactory(): PublicClientApplication{
  const instance = new PublicClientApplication(msalConfig);
  return instance;
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration{
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: environment.appFrontend.redirect.scopes
    },
    loginFailedRoute: ('/' + routesPath.login)
  };
}

export function MSALInterceptorConfigFactory():MsalInterceptorConfiguration {
   const protectedResourceMap = new Map<string, Array<string>>();
   protectedResourceMap.set(environment.entraId.endpoint,environment.entraId.scopes);
   protectedResourceMap.set(environment.appBackend.apiUrlBase + '/*', [environment.appBackend.accessScope]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: protectedResourceMap
  };

}